export default __webpack_public_path__ + "static/media/grainBuds_01.75895059.png";